<template>
    <Modal v-model="show"
        title="现售 - 转运站发货"
        :width="1200"
        :footer-hide="true"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top">

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="现售单编号">
                            <Input :value="orderRecord.curSaleOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员名称">
                            <Input :value="orderRecord.deliveryAddressContacts"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="orderRecord.deliveryAddressPhone"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="会员账户余额">
                            <Input :value="memberFundInfo.memberFundBalance"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="会员定金余额">
                            <Input :value="memberFundInfo.memberDepositBablance"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="现售单日期">
                            <Input :value="formatDateTimeString(orderRecord.curSaleOrderRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <!-- 
                        <Col span="2">
                        <FormItem label="现售单状态">
                            <Input :value="orderRecord.orderStatus"
                                readonly></Input>
                        </FormItem>
                        </Col> -->
                    </Row>

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="收货区域">
                            <Input :value="orderRecord.dist"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="物流配置">
                            <Input :value="logisticsInfo.logisticsDistName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="物流公司">
                            <Input :value="logisticsInfo.logisticsCompanyName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="物流单价">
                            <Input :value="logisticsInfo.logisticsCompanyPrice"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="物流费用">
                            <Input-number v-model="orderRecord.curSaleOrderRecordStationDeliveryFee"
                                :readonly="orderRecord.curSaleOrderRecordIsPaidDeliveryFee === 1"
                                style="width:100%;">
                            </Input-number>
                        </FormItem>
                        </Col>
                        <Col v-if="orderRecord.curSaleOrderRecordIsPaidDeliveryFee === 0"
                            span="4">
                        <FormItem label=" ">
                            <Button type="primary"
                                @click="OnPayDeliveryFee">收取物流费</Button>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="productTable"
                            size="small"
                            :columns="productTable.columns"
                            :data="orderDetails"
                            highlight-row
                            stripe
                            border />
                        </Col>
                    </Row>

                    <Row v-if="orderRecord.curSaleOrderRecordIsPaidDeliveryFee === 1"
                        :gutter="16"
                        class="row-margin-top-15"
                        style="margin-top:10px;"
                        type="flex"
                        justify="space-between">
                        <Col span="10">
                        <DatePicker :value="form.deliveryDate"
                            type="date"
                            format="yyyy-MM-dd"
                            placeholder="请填写发货日期"
                            @on-change="onDeliveryDateChange" />
                        <Button type="primary"
                            @click="onSubmit">发货</Button>
                        <Button type="success"
                            style="margin-left:5px;"
                            @click="printDeliveryRecord()">打印送货单</Button>
                        </Col>
                        <Col span="10">
                        <div style="text-align:right;">
                            <span>转运站发货量:{{productTable.totalQuantity}}</span>
                            <span style="margin-left:20px;">转运站发货金额:{{numberToFixed(productTable.totalValue,2)}}</span>
                        </div>

                        </Col>
                    </Row>

                </Form>
                </Col>
            </Row>

            <Row :gutter="16"
                class="row-margin-top-15"
                style="margin-top:10px;">
                <Col spal="24">
                <Collapse :value="[]">
                    <Panel name="curSale">
                        历史发货单
                        <div slot="content">
                            <Table ref="deliveryHistoryTable"
                                size="small"
                                :columns="deliveryHistoryTable.columns"
                                :data="deliveryDetails"
                                stripe
                                border />
                        </div>
                    </Panel>
                </Collapse>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import DecimalInput from '@/components/number-input/decimal-input';
import CurrencyInput from '@/components/number-input/currency-input';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { FILE_SERVER } from '@/api/modules/files';
import { numberToFixed } from '@/components/number-input/display-format';

import {
    getCurSaleDistributionStationDeliveryDetail,
    saveCurSaleDistributionStationDelivery,
    saveCurSaleDeliveryFee,
    printCurSaleDistributionStationDeliveryDetail
} from '@/api/modules/distributionStation-management/distributionStation-delivery';

export default {
    name: 'CurSaleDistributionStationDeliveryEdit',
    components: {
        CurrencyInput
    },
    data() {
        return {
            show: false,
            recordUuid: '',
            seedFarmUuid: '',
            innerSpin: false,
            curSaleOrderRecordUuid: '',
            orderRecord: {
                curSaleOrderRecordUuid: '',
                curSaleOrderRecordCode: '',
                curSaleOrderRecordCreateAt: '',
                orderStatus: '',
                curSaleOrderRecordStationDeliveryFee: 0,
                curSaleOrderRecordIsPaidDeliveryFee: 0

            },
            memberFundInfo: {
                memberFundBalance: 0,
                memberDepositBablance: 0
            },
            logisticsInfo: {
                logisticsCompanyName: '',
                logisticsCompanyPrice: 0,
                logisticsCompanyUuid: '',
                logisticsDistName: ''
            },
            orderDetails: [],
            deliveryDetails: [],
            productStores: [],
            productTable: {
                columns: [
                    { title: '产品编码', key: 'curSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'curSaleOrderDetailProductName', align: 'center' },
                    { title: '单位', key: 'curSaleOrderDetailProductUnit', align: 'center' },
                    { title: '批次', key: 'curSaleOrderDetailStoreBatchCode', align: 'center' },
                    { title: '销售周期', key: 'curSaleOrderDetailStoreSalePeriod', align: 'center' },
                    { title: '单价', key: 'curSaleOrderDetailProductDisplayPrice', align: 'center' },
                    { title: '订购量', key: 'curSaleOrderDetailOrderQuantity', align: 'center' },
                    { title: '库存量', key: 'storeAmount', align: 'center' },
                    { title: '客户累计收货量', key: 'curSaleOrderDetailCustomerReceiveQuantity', align: 'center' },
                    {
                        title: '发货量',
                        key: 'deliveryAmount',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.curSaleOrderDetailCustomerReceiveQuantity === 0 && params.row.storeAmount > 0) {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.deliveryAmount,
                                        max: params.row.curSaleOrderDetailOrderQuantity,
                                        precision: 0
                                    },
                                    on: {
                                        change: newVal => {
                                            this.orderDetails[params.index].deliveryAmount = newVal;
                                            this.calculateTotalDeliveryAmount();
                                        }
                                    }
                                });
                            }
                            else {
                                return h('div', [
                                    h('span', '-')
                                ]);
                            }
                        }
                    },
                    {
                        title: '备注', key: 'remark', width: 200, align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: params.row.remark
                                },
                                on: {
                                    'on-change': newVal => {
                                        this.orderDetails[params.index].remark = newVal.target.value;
                                    }
                                }
                            });
                        }
                    }

                ],
                totalQuantity: 0,
                totalValue: 0
            },
            deliveryHistoryTable: {
                columns: [
                    { title: '发货单号', key: 'distributionStationDeliveryRecordCode', width: 200, align: 'center' },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '产品名称', key: 'productName', width: 120, align: 'center' },
                    { title: '单位', key: 'unitName', width: 60, align: 'center' },
                    { title: '送货数量', key: 'distributionStationDeliveryQuantity', width: 80, align: 'center' },
                    { title: '收货数量', key: 'distributionStationDeliveryDetailComplainRecevieCount', width: 80, align: 'center' },
                    { title: '投诉数量', key: 'distributionStationDeliveryDetailComplainQualityCount', width: 80, align: 'center' },
                    { title: '投诉信息', key: 'distributionStationDeliveryDetailComplainInfo', align: 'center' },
                    { title: '制单人', key: 'ownerName', width: 80, align: 'center' },
                    { title: '制单时间', key: 'distributionStationDeliveryRecordCreateAt', width: 120, align: 'center', render: (h, parmas) => dateTimeRender(h, parmas.row.distributionStationDeliveryRecordCreateAt) }
                ]
            },
            form: {
                deliveryDate: ''
            }
        };
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(recordUuid, seedFarmUuid, deliveryUuid) {
            this.recordUuid = recordUuid;
            this.seedFarmUuid = seedFarmUuid;
            this.deliveryUuid = deliveryUuid;
            this.show = true;
            console.log(deliveryUuid);
        },
        formatDateString,
        formatDateTimeString,
        numberToFixed,
        printDeliveryRecord() {
            this.innerSpin = true;
            printCurSaleDistributionStationDeliveryDetail(this.curSaleOrderRecordUuid).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    window.open(FILE_SERVER + res.data.url, "_blank");
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        calculateTotalDeliveryAmount() {
            this.productTable.totalQuantity = this.orderDetails.map(e => {
                return e.deliveryAmount;
            }).reduce((total, num) => {
                return total + num;
            });

            this.productTable.totalValue = this.orderDetails.map(e => {
                return e.deliveryAmount * e.curSaleOrderDetailProductDisplayPrice;
            }).reduce((total, num) => {
                return total + num;
            });
        },
        OnPayDeliveryFee() {
            if (this.orderRecord.curSaleOrderRecordStationDeliveryFee === null
                || this.orderRecord.curSaleOrderRecordStationDeliveryFee < 0) {
                this.$Modal.error({ title: '运费不能小于0元', content: '' });
                return;
            }
            this.$Modal.confirm({
                title: '确认收取运费: ' + this.orderRecord.curSaleOrderRecordStationDeliveryFee + ' 元？',
                onOk: () => {
                    let data = {
                        curSaleOrderRecordUuid: this.orderRecord.curSaleOrderRecordUuid,
                        deliveryFee: this.orderRecord.curSaleOrderRecordStationDeliveryFee
                    };
                    saveCurSaleDeliveryFee(data).then(res => {
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('运费收取成功');
                        }
                    });
                }
            });
        },
        onDeliveryDateChange(date) {
            this.form.deliveryDate = date;
        },
        init() {
            if (this.recordUuid) {
                this.curSaleOrderRecordUuid = this.recordUuid;
                this.innerSpin = true;
                getCurSaleDistributionStationDeliveryDetail(this.curSaleOrderRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.orderRecord = Object.assign(this.orderRecord, res.data.orderRecord);
                        this.productStores = res.data.productStores;
                        this.memberFundInfo = res.data.memberFundInfo;
                        this.orderDetails = res.data.orderDetails.filter(e => {
                            return e.productRelateSeedFarmUuid === this.seedFarmUuid;
                        }).map(item => {
                            const productUuid = item.curSaleOrderDetailProductUuid;
                            const query = this.productStores.find(s => s.distributionStationProductStoreProductUuid === productUuid);
                            let storeAmount = 0;
                            let deliveryAmount = 0;
                            let remark = '';
                            if (query) {
                                storeAmount = query.distributionStationProductStoreAmount;
                                deliveryAmount = storeAmount >= item.curSaleOrderDetailOrderQuantity ? item.curSaleOrderDetailOrderQuantity : 0;
                            }

                            return Object.assign(item, { storeAmount, deliveryAmount, remark });
                        });
                        this.calculateTotalDeliveryAmount();

                        this.deliveryDetails = res.data.deliveryDetails;

                        this.logisticsInfo = Object.assign(this.logisticsInfo, res.data.logisticsInfo);

                        if (this.logisticsInfo.logisticsCompanyUuid === '') {
                            this.$Modal.warning({
                                title: '警告',
                                content: `尚未配置到 【${this.orderRecord.dist}】 的物流信息，请先设置`
                            });
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }

        },
        onSubmit() {
            if (this.logisticsInfo.logisticsCompanyUuid === '') {
                this.$Modal.warning({
                    title: '警告',
                    content: `尚未配置到 【${this.orderRecord.dist}】 的物流信息，请先设置`
                });
                return;
            }
            const submitData = {
                curSaleOrderRecordUuid: this.curSaleOrderRecordUuid,
                curSaleDeliveryRecordUuid: this.deliveryUuid,
                deliveryDate: this.form.deliveryDate,
                deliveryFee: this.orderRecord.curSaleOrderRecordStationDeliveryFee,
                deliveryItems: this.orderDetails.filter(p => {
                    return p.deliveryAmount >= 0;
                }).map(p => {
                    return {
                        curSaleOrderDetailUuid: p.curSaleOrderDetailUuid,
                        quantity: p.deliveryAmount,
                        remark: p.remark
                    };
                })
            };

            if (submitData.deliveryDate === '') {
                this.$Modal.error({ title: '出错啦', content: '送货日期不能为空' });
                return;
            }

            let zeroQuanityItems = submitData.deliveryItems.filter(e => {
                return e.quantity === 0;
            });

            if (zeroQuanityItems.length > 0) {
                this.$Modal.confirm({
                    title: '存在发货数量为零的商品，确认要发货？',
                    onOk: () => {
                        this.innerSpin = true;
                        saveCurSaleDistributionStationDelivery(submitData).then(res => {
                            this.innerSpin = false;
                            if (res.code === 0) {
                                this.$Message.success('保存成功');
                                this.show = false;
                                this.$parent.init();
                            }
                        }).catch(() => {
                            this.innerSpin = false;
                        });
                    }
                });
            }
            else {
                this.innerSpin = true;
                saveCurSaleDistributionStationDelivery(submitData).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.init();
                            }
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        }
    }
};
</script>

<style scoped>
</style>
